<template>
  <div class="home-constructor">
    <div class="home-header">
      <div class="header-left-constructor">
        <Logo :style="{ height: '72%' }" />
      </div>
      <div class="header-right-constructor">
        <div class="header-title">
          <CreateLayer 
            v-if="map"
          ></CreateLayer>
        </div>
        <DownloadCenter
          :style="{
            width: '1.625rem',
            height: '1.625rem',
            padding: '0.125rem',
            'border-radius': '0.3125rem',
            '--userIconColor': 'var(--iconColor_3)',
          }"
        />
        <UserInfo
          :style="{
            width: '1.625rem',
            height: '1.625rem',
            padding: '0.125rem',
            'border-radius': '0.3125rem',
            '--userIconColor': 'var(--iconColor_3)',
          }"
          :centerShow="true"
          :ThemeToggleShow="false"
          :updatePwdShow="true"
        />
      </div>
    </div>
    <div class="home-body" id="home-body"
      :style="{
        '--nav-panel-width': isCollapsed?'3rem':'20rem',
        '--nav-collapsed-duration': '0.4s',
      }"
    >
      <LeafletConstructor
        ref="leafletConstructor"
        @mapInit="homeMapInit"
        :isAddBaseLayer="false"
        :layerControl="false"
        :search="true"
      />
      <!-- <ManagePanel
        v-if="map"
      /> -->
      <WorkBench v-if="map"></WorkBench>
      <ShootDataView v-if="map"></ShootDataView>
      <StravaInit v-if="map"></StravaInit>
      <!-- 底图对比功能因单选架构暂时挂起 -->
      <!-- <SideMap v-if="map"></SideMap> -->
      <GlobalRegionDirectory v-if="map && !isWorkMode"></GlobalRegionDirectory>
      
      <!-- <div id="tool-control-left-container"> -->
      <!-- </div> -->
      <!-- <LayerInfoPreview
        @close="()=>{ console.log(123213); }"
        :target="testJson"
      ></LayerInfoPreview> -->
    </div>
  </div>
</template>

<script setup>
import {
  ref, onMounted, onUnmounted, createApp, h, computed, toRaw 
} from 'vue'
import { message } from '@/utils/js/initVariable'
import store from '@/store'
import { svgControlCreate, markerComControlCreate } from '@/utils/js/leafletUtils'
import LeafletConstructor from '@/components/LeafletConstructor'
import Logo from '@/components/Logo'
import UserInfo from '@/components/UserInfo'
import DownloadCenter from '@/views/DownLoadCenter'
// import ManagePanel from './component/ManagePanel';
import CreateLayer from '@/components/CreateLayer';
import WorkBench from '@/views/WorkBench/index.vue';
import ShootDataView from '@/views/ShootDataView';
import StravaInit from '@/views/StravaInit';
import SideMap from '@/views/Home/component/SideMap';
import GlobalRegionDirectory from '@/views/WorkBench/components/GlobalRegionDirectory/index.vue';

// 标注详情预览
import LayerInfoPreview from '@/components/LayerInfoPreview';
import axios from 'axios'

const eventType = ref('L.Draw.Event.CREATE');
const map = ref()
const leafletConstructor = ref();

const isCollapsed = computed(()=> store.getters['isCollapsed'])
const isWorkMode = computed(() => store.getters['isWorkMode']);

const copyLatLng = (event)=>{
  const latlng = event.latlng;
  const lat = latlng.lat.toFixed(4),
        lng = latlng.lng.toFixed(4);
  if(latlng && navigator && navigator.clipboard && navigator.clipboard.writeText){
    latlng && navigator && navigator.clipboard.writeText(
      `${ lat },${ lng }`
    );
  }else{
    const save = function(e) {
      e.clipboardData.setData('text/plain', `${ lat },${ lng }`)
      e.preventDefault() // 阻止默认行为
    }
    document.addEventListener('copy', save) // 添加一个copy事件
    document.execCommand('copy') // 执行copy方法
  }
}

onMounted(() => {
  store.commit('isHomePageChange', true);
});

const homeMapInit = (m) => {
  map.value = m
  store.commit('setHomeMap', m);
  m.on('click', copyLatLng);
};

// 组件销毁时清理
onUnmounted(() => {
  store.commit('isHomePageChange', false);
  if(!map.value)return;
  const rawMap = toRaw(map.value);
  rawMap.off && rawMap.off('click', copyLatLng);
});
</script>

<style lang='less' scoped>
.homeheader-notice-title {
  display: flex;
  justify-content: space-between;
}
</style>

<style lang='less' scoped>
.home-constructor{
  height: 100vh;
  width: 100%;
  --homeHeaderHight: 40px;
  .home-header{
    position: relative;
    z-index: 10;
    height: var(--homeHeaderHight);
    width: 100%;
    background-color: var(--backgroundColor);
    padding: 4px 10px;
    display: flex;
    --headerLeftWidth: 240px;
    transition: all 0.4s;
    // border-bottom: 1px solid var(--borderColor);
    text-shadow: 0 4px 4px rgba(54, 54, 54, 0.1);
    .header-left-constructor{
      // width: var(--headerLeftWidth);
      flex: 0;
      display: flex;
      align-items: center;
      .button-list{
        display: flex;
        width: 200px;
        margin-left: 50px;
        justify-content: space-between;
      }
      img{
        height: 90%;
      }
      color: var(--fontColor);
      line-height: calc(var(--homeHeaderHight) - 4px * 2);
      text-align: center;
      text-shadow: 0 0 1px var(--domFontColor);
      font-size: 27px;
      // font-family: 'OPPOSans-H';
      font-weight: bold;
    }
    .header-right-constructor{
      height: 100%;
      // width: calc(100% - var(--headerLeftWidth) - 10px);
      // border-left: 1px solid rgb(128, 128, 128);
      display: flex;
      flex: 1;
      margin-left: 10px;
      --headerSearchWidth: 220px;
      --headerSearchWidth: 0px;
      align-items: center;
      .header-title{
        width: calc(100% - var(--headerSearchWidth));
        height: 100%;
        line-height: calc(var(--homeHeaderHight) - 4px * 2);
        text-align: center;
        text-shadow: 0 0 1px var(--domFontColor);
        font-size: 27px;
        // font-family: 'OPPOSans-H';
        font-weight: bold;
        img{
          height: 30px;
          vertical-align: -0.15rem;
        }
        span {
          font-family: 'OPPOSans';
          text-shadow: 1px 1px 0 rgba(0, 122, 255, 15%), -1px -1px 0 rgba(0, 122, 255, 15%), 1px -1px 0 rgba(0, 122, 255, 15%), -1px 1px 0 rgba(0, 122, 255, 15%);
        }
      }
      .header-search{
        width: var(--headerSearchWidth);
        height: 100%;
        padding: 0 5px;
        // input{
        //   outline: none;
        //   height: 100%;
        //   width: 100%;
        //   border-radius: 5px;
        //   background-color: transparent;
        //   border: 1px solid rgb(128, 128, 128);
        //   padding: 0 5px;
        //   color: rgb(128, 128, 128);
        // }
      }
      .header-notice {
        margin-right: 20px;
      }
    }
  }
  .home-body{
    position: relative;
    z-index: 0;
    width: 100%;
    height: calc(100% - var(--homeHeaderHight));
    #tool-control-left-container{
      position: absolute;
      left: 10px;
      top: 10px;
      #tool-control-left-content{
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
}


</style>